import {createEffect, createSignal, onMount, Show, onCleanup, on, onError, Switch, Match, For} from 'solid-js'
import {AuthorizationContext} from './AuthorizationContext'
import {AuthorizationHandler, AuthorizationType, AuthorizerOptions} from './authorizationHandler'
import {FocusGroupProvider, FocusableProvider, LoadingScreen, Spinner, ToastType, useConfig, useIcon, useToast} from '../components'
import {profileSelector, useDispatch, useSelector} from '../store'
import './AuthorizationProvider.css'
import {
    fetchProfile,
    authenticate,
    logout,
    initGuestMode,
    clearOauthData,
    geneateAuthToken,
    verifyOTPCode,
    pushNotification,
    resetDeviceList,
    setLocale,
    getTvServices,
    loginTvService,
    isConnectedInOperatorNetwork
} from '@te/volt-store/lib/actions'
import {getDeviceInfo, isBackKey, isPlatform, LocalStorageKeys} from '../utils'
import {Login} from '../components/login/login'
import {LoginTVTab} from '../components/logintvtab/logintvtab'
import {LoginTVForm} from '../components/logintvform/logintvform'
import {LoginLanguage} from '../components/loginlanguage/loginlanguage'
import {getDeviceData} from '../utils'
import {isWeb} from '../utils/isWeb'
import {NewLogin} from '../components/newLogin/newLogin'
import LoginOtp from '../components/loginOtp/loginOtp'
import {useI18n} from '../i18n'
import WhereIsMyUsername from '../components/whereIsMyUserName/whereIsMyUsername'
import {SoloNoInternetScreen} from '../components/soloNoInternetScreen/soloNoInternetScreen'
import { QrLogin } from '../components/qrLogin/qrLogin'
import { clearTvids, cancelAuthenticationWithSecondaryDevice, authenticateWithSecondaryDevice, authenticateWithSecureId } from '@te/volt-store/lib/actions';
import ForgotPassword from '../components/forgotPassword/forgotPassword'
import { useSpatialNavigation } from '../spatialNavigation'
import { SubscriptionSelector } from '../components/subscription-selector/SubscriptionSelector'
import QuitPopUp from '../components/quitPopUp/QuitPopUp'


interface AuthorizationProviderProps {
    voltApi: any
    children: any
}
export const AuthorizationProvider = (props: AuthorizationProviderProps) => {
    let progressInterval: any
    const [authorizationHandler, setAuthorizationHandler] = createSignal<AuthorizationHandler>()
    const {getConfig} = useConfig()
    const {getI18n} = useI18n()
    const { show } = useToast()
    const dispatch = useDispatch()
    const profile = useSelector(profileSelector)
    const authenticationStatus = useSelector((s: {auth: {authenticationStatus: string}}) => s.auth.authenticationStatus)
    const authenticationStatusErrorCode = useSelector((s: {auth: {authenticationStatusErrorCode: string}}) => s.auth.authenticationStatusErrorCode)
    const services = useSelector((s: any) => s.auth.tvServices)
    const {setFocus, getCurrentFocusKey} = useSpatialNavigation()

    const authConfig: AuthorizerOptions = {
        allowGuest: getConfig().allowGuest,
        clientId: getConfig().clientId,
        clientSecret: getConfig().clientSecret,
        redirectUri: window.location.origin + '/oauthredirect',
        authorizationType: AuthorizationType.REDIRECT,
        responseType: AuthorizationType.TOKEN,
        grant_type: getConfig().grant_type,
        scope: '',
        authorityConfiguration: {
            authorization_endpoint: getConfig().urls.authUrl + getConfig().OAuthParam?.endpoint?.auth,
            token_endpoint: getConfig().OAuthParam?.endpoint?.fullTokenUrl
                ? getConfig().OAuthParam?.endpoint?.fullTokenUrl
                : getConfig().urls.authUrl + getConfig().OAuthParam?.endpoint?.token,
            revocation_endpoint: '',
            registration_endpoint: '',
        },
    }

    const isAuthPending = useSelector((state: {auth: {isPending: any}}) => state.auth.isPending)
    const isLogoutPending = useSelector((state: {auth: {isLogoutPending: any}}) => state.auth.isLogoutPending)
    const isLogoutError = useSelector((state: {auth: {isLogoutError: any}}) => state.auth.isLogoutError)

    const [waitForProfile, setWaitForProfile] = createSignal(false)
    const [profileFailed, setProfileFailed] = createSignal(false)
    const [isGuestOpted, setIsGuestOpted] = createSignal(
        getConfig()?.allowGuest && localStorage.getItem('guestOpted') === 'true'
    )
    const [showLoginTVLang, setShowLoginTVLang] = createSignal(true)
    const [showLoginTVTab, setShowLoginTVTab] = createSignal(false)
    const [showLoginTVForm, setShowLoginTVForm] = createSignal(false)
    const [showForgotPasswordTV, setForgotPasswordTV] = createSignal(false)
    const [showNewLoginForm, setShowNewLoginForm] = createSignal(true)
    const [showNewLoginOtp, setShowNewLoginOtp] = createSignal(false)
    const [showWhereIsMyUsername, setshowWhereIsMyUsername] = createSignal(false)
    const [username, setUsername] = createSignal('')
    const [password, setPassword] = createSignal('')
    const [isLoggingOut, setIsLoggingOut] = createSignal(false)
    const [usernameOrEmail, setUsernameOrEmail] = createSignal<any>('')
    const [otpText, setOtpText] = createSignal('')
    const [eDSConnectivity, setEDSConnectivity] = createSignal("PENDING")
    const [isSubmitting, setIsSubmitting] = createSignal(false);
    const [showTvidSelection, setShowTvidSelection] = createSignal(false);
    const [isSubmittingOoredoo, setIsSubmittingOoredoo] = createSignal(false);
    const [showExitPopUp, setShowExitPopUp] = createSignal<{ show: boolean, lastFocused: string }>({ show: false, lastFocused: '' })

    const unsupportedDeviceTypes = ['smartphone', 'tablet', 'phablet', 'mobile']
    const isDeviceUnSupported = unsupportedDeviceTypes.includes(getDeviceInfo().device?.type ?? 's')
    const icons = useIcon()
    const locale = useSelector((state: any) => state?.language?.locale)
    const [isLoading, setIsLoading] = createSignal(true);
    const OAuthStatus = useSelector((s: any) => s.auth.oauthDeviceFlowStatus)
    const [tab, setTab] = createSignal<number>(0); // Signal to track the active tab
    const [isLoginTvComplete, setLoginTvComplete] = createSignal(true) //it used to show error message in login formm, after error message dispaly it will load QR
    const [isCurrentInternetStatus, setCurrentInternetStatus] = createSignal(true) 
    const [isPrevInternetStatus, setPrevInternetStatus] = createSignal(true) 

    createEffect(() => {
        if (profile() && !isGuestOpted()) {
            setWaitForProfile(false)
        }
        if(profile()?.isKidProfile) {
            localStorage.setItem("isKidsProfile", JSON.stringify(true))
            localStorage.setItem("SwitchToKids", "KIDS")
        }
    })    
    createEffect(()=>{

        if(getConfig()?.authenticationTypeTv?.includes('solo'))
        {
            dispatch(isConnectedInOperatorNetwork({"onSuccess": ()=>{ setEDSConnectivity("CONNECTED") }, "onFailed": () => { setEDSConnectivity("DISCONNECTED") }, "retries": [] }));
        }
        else
        {
            setEDSConnectivity("CONNECTED");
        }
    })

    createEffect(
        on([() => isLogoutPending(), () => isLogoutError()], () => {
            if (isLogoutPending()) {
                setIsLoggingOut(true)
            }

            if (isLoggingOut() && !isLogoutPending() && !isLogoutError()) {
                if (isPlatform('laptop')) {
                    setWaitForProfile(localStorage.getItem('guestOpted') !== 'true')
                    setProfileFailed(localStorage.getItem('guestOpted') !== 'true')
                } else {
                    setWaitForProfile(true)
                    setProfileFailed(false)
                    if(isPlatform('tizen') && window?.parent !== window?.self) {
                        window?.parent?.postMessage?.('reload', 'file://')
                    } else if (window?.tizen) {
                        window.location.href = "index.html"
                    } else {
                        window.location.href = '/'
                    }
                }
                setShowLoginTVLang(true)
                setShowLoginTVForm(false)
                setUsername('')
                setPassword('')
            }
        })
    )

    createEffect(() => {
        if (authenticationStatus() === 'SUCCEEDED') {
            resetStates()
        }
    })

    function handleLoginTVTab() {
        setShowLoginTVTab(true)
    }

    function handleLoginSettingsTVTab() {
        setShowLoginTVTab(true)
    }

    const isInternetConnected = (callback: any) => {
        if (window.navigator.onLine) {
            callback?.()
        } else {
            dispatch(
                pushNotification({
                    message: {
                        title:'NO_INTERNET',
                        tag: getI18n()?.formatMessage({id: 'NO_INTERNET'}),
                        type: "error",
                    },
                })
            )
        }
    }

    const handleTvLogin = async (username: string, password: string) => {
        if(isSubmitting()) {
            return
        }
        //Username validation
        if (username == '') {
            show({title: '', description: getI18n()?.formatMessage({id: 'LOGIN_FAILED_USERNAME_OR_EMAIL_REQ'}), type: ToastType.INFO})
            return
        }

        //Password validation
        if (password == '') {
            show({title: '', description: getI18n()?.formatMessage({id: 'LOGIN_FAILED_PASS_REQ'}), type: ToastType.INFO})
            return
        }
        setLoginTvComplete(false)
        setIsSubmitting(true)
        setIsSubmittingOoredoo(true)
        setUsername(username)
        setPassword(password)
        const deviceData = getDeviceData()
        const deviceid = isWeb ? 1 : 3
        // added bellow for QR to cancel status after click on login button
        getConfig().userAuthType === 'BOTH' && getConfig()?.authenticationTypeQr === 'device' && await dispatch(cancelAuthenticationWithSecondaryDevice())
        //end
        await dispatch(
            authenticate({
                loginType: props.voltApi.Constants.loginType.USERNAME_AND_PASSWORD,
                username,
                password,
                deviceData: {
                    ...deviceData,
                    deviceId: deviceid,
                },
            })
        )
    }

    createEffect(
        on(
            [() => services(),() => authenticationStatus()],
            () => {
                setShowTvidSelection(false)
                if (
                    services() &&
                    authenticationStatus() ===
                        props.voltApi.Constants.authenticationStatus.SUCCEEDED_REQUIRE_LOGIN_TV_SERVICE
                ) {
                    if (services().length === 1) {
                        dispatch(loginTvService({serviceId: services()[0].serviceId, deviceData: getDeviceData()}))
                    } else {
                        !isWeb && setShowTvidSelection(true)
                    }
                }
            }
        )
    )

    createEffect(() => {
        if (authenticationStatus() === props?.voltApi?.Constants.authenticationStatus.FAILED) {
            //setIsSubmitting is used in qr with login form 
            setIsSubmitting(false)
            setIsSubmittingOoredoo(false)
            setShowLoginTVForm(false)
        }

        if(!isWeb && authenticationStatus() === props?.voltApi?.Constants.authenticationStatus.SUCCEEDED_REQUIRE_LOGIN_TV_SERVICE) {
            dispatch(getTvServices())
        }
    })

    const backKeyHandler = (event: any) => {
        
        if (isBackKey(event)) {
            if(showTvidSelection()){
                setShowTvidSelection(false)
                setIsSubmitting(false)
                dispatch(cancelAuthenticationWithSecondaryDevice())
                secondaryAuthenticate(OAuthStatus()?.status)
                dispatch(clearTvids())
            } 
            else if(showLoginTVTab() && !showLoginTVForm() && showLoginTVLang() && !showNewLoginForm() && (showNewLoginOtp() || showWhereIsMyUsername()))
            {
                setShowNewLoginOtp(false)
                setShowNewLoginForm(true)
                setshowWhereIsMyUsername(false)
            }
            else if (!showLoginTVTab() && !showLoginTVForm() && showLoginTVLang() && isPlatform('laptop')) {
                setShowLoginTVLang(true)
            } 
            else if (showLoginTVTab() && !showLoginTVForm() && showLoginTVLang() && isPlatform('laptop')) {
                setShowLoginTVTab(false)
            } else if (!showNewLoginForm() && (showNewLoginOtp() || showWhereIsMyUsername())) {
                resetStates()
            } else if (showExitPopUp()?.show) {
                updateExitStatus(false)
            } else if (!profile() && !showForgotPasswordTV()) {
                setShowExitPopUp({
                    show: true,
                    lastFocused: getCurrentFocusKey(),
                    isInput: false
                })
                setFocus('confirm')
            }
        }
    }

    // disable login and language for STV
    createEffect(() => {
        if (!isPlatform('laptop'))
            {
            setShowLoginTVLang(true)
            setShowLoginTVTab(true)
        } 
    });

    const getAuthKey = () => {
        return getConfig()?.authenticationTypeTv?.includes('iptv') || getConfig()?.authenticationTypeTv?.includes('solo')
            ? getConfig()?.client === 'starhub' ? LocalStorageKeys.SECONDARY_ACCESS_TOKEN : LocalStorageKeys.SESSION_COOKIE
            : LocalStorageKeys.OIDC_OAUTH_TOKEN
    }

    onCleanup(() => {
        window.removeEventListener('keydown', backKeyHandler)
        clearInterval(progressInterval)
    })

    onMount(async () => {

        window.addEventListener('keydown', backKeyHandler)

        if (!localStorage.getItem('guestOpted')) {
            localStorage.setItem('guestOpted', 'false')
        }
        if (getConfig()?.authenticationType === 'oauth') {
            const _authzHandler = new AuthorizationHandler(authConfig)
            setAuthorizationHandler(_authzHandler)
        }
        if (localStorage.getItem('LOCALE')) {
            dispatch(setLocale(localStorage.getItem('LOCALE')))
        }
        if (window.location.pathname !== '/oauthredirect' && !isDeviceUnSupported) {
            if (isGuestOpted()) {
                setWaitForProfile(false)
            } else if (localStorage.getItem(getAuthKey()) === null) {
                setWaitForProfile(true)
            } else if (!profile() && localStorage.getItem(getAuthKey()) !== null) {
                dispatch(authenticateWithSecureId())
                setWaitForProfile(true)
                dispatch(
                    fetchProfile({
                        onSuccess: () => {
                            setProfileFailed(false)
                        },
                        onError: () => {
                            setProfileFailed(true)
                            dispatch(logout({onSuccess: () => {}}))
                        },
                        isLogin: true,
                    })
                )
            }
        }
    })

    const resetStates = () => {
        dispatch(resetDeviceList())
        localStorage.setItem('timer', '0')
        setUsernameOrEmail('')
        setUsername('')
        setShowNewLoginForm(true)
        setShowNewLoginOtp(false)
        setshowWhereIsMyUsername(false)
    }

    const onClickLoginButtonHandler = () => {
        isInternetConnected(() => {
            if (usernameOrEmail()) {
                setShowNewLoginForm(false)
                setShowNewLoginOtp(false)
                setIsSubmittingOoredoo(true)
                dispatch(
                    geneateAuthToken({
                        serviceNumber: usernameOrEmail(),
                        onSuccess: (response: any) => {
                            if (response.response?.operationResult == 'SUCCESS') {
                                setOtpText(response.response?.primaryNumber)
                                setIsSubmittingOoredoo(false)
                                setShowNewLoginOtp(true)
                            } else {
                                setShowNewLoginForm(true)
                                setIsSubmittingOoredoo(false)
                            }
                        },
                        onError: (err: any) => {
                            setShowNewLoginForm(true)
                            setIsSubmittingOoredoo(false)
                            dispatch(
                                pushNotification({
                                    message: {
                                        tag: `GENERATE_OTP_${err?.backendErrorCode}`,
                                        type: 'failure',
                                        params: {
                                            title: err?.backendErrorMessage,
                                        },
                                    },
                                })
                            )
                        },
                    })
                )
                return
            }
            else if (usernameOrEmail().length !== 8 || isNaN(usernameOrEmail())) {
                dispatch(
                    pushNotification({
                        message: {
                            tag: getI18n()?.formatMessage({id: 'ERROR_GENERATE_OTP_100'}),
                            type: "information",
                        },
                    })
                )
                return
            }
        })
    }

    const onCompleteOtp = (pinCode: any) => {
        isInternetConnected( async () => {
            setIsSubmittingOoredoo(true)
            setShowNewLoginForm(false)
            setShowNewLoginOtp(false)
            await dispatch(
                verifyOTPCode({
                    otp: pinCode,
                    serviceNumber: usernameOrEmail(),
                    onSuccess: (response: any) => {
                        setIsSubmittingOoredoo(false)
                        setTimeout(() => setShowNewLoginOtp(true), 2000)
                        if (response.response?.operationResult == 'SUCCESS') {
                            localStorage.setItem('USER_ID', response.response?.iptvAccountNumber)
                            handleTvLogin(response.response?.iptvAccountNumber, '1111')
                        }
                    },
                    onError: (err: any) => {
                        setIsSubmittingOoredoo(false)
                        setShowNewLoginOtp(true)
                        dispatch(
                            pushNotification({
                                message: {
                                    tag: `VERIFY_OTP_${err?.backendErrorCode}`,
                                    type: 'failure',
                                    params: {
                                        title: err?.backendErrorMessage,
                                    },
                                },
                            })
                        )
                    },
                })
            )
        })
    }

    const guestLogin =  () => {
        dispatch(logout({onSuccess: () => {
            dispatch(clearOauthData())
        }}))
        dispatch(initGuestMode())
        setWaitForProfile(false)
        setProfileFailed(false)
        localStorage.setItem('guestOpted', 'true')
        setIsGuestOpted(true)
        if (
            window.location.pathname.includes('oauthredirect') ||
            window.location.pathname.includes('recordings') ||
            window.location.pathname.includes('store')
        ) {
            window.location.href = '/'
        } else {
            window.location.reload()
        }
    }

    const onClickUsernameButton = () => {
        setShowNewLoginForm(false)
        setShowNewLoginOtp(false)
        setshowWhereIsMyUsername(true)
    }

    const onCheckEDSConnectivity = async () =>{
        setEDSConnectivity("");
        setIsSubmittingOoredoo(true)
        setShowNewLoginForm(false)
        setShowNewLoginOtp(false)
        dispatch(
            isConnectedInOperatorNetwork(
                {
                    "onSuccess": () =>
                        { 
                        setEDSConnectivity("CONNECTED") 
                        // added bellow check for tabs loader
                        setIsSubmittingOoredoo(false)
                        setShowNewLoginForm(true)
                        setShowNewLoginOtp(false)
                }, 
                    "onFailed": () => 
                        {
                    setEDSConnectivity("DISCONNECTED") 
                    // added bellow check for tabs loader
                    setIsSubmittingOoredoo(false)
                    setShowNewLoginForm(true)
                    setShowNewLoginOtp(false)
                }, 
                "retries": [] 
            }
        ));
    }

    //Qr code start
    //used bellow to set loginFormAuthComplete, so then QR code will generate
    const handleLoginTVComplete =() =>{
        setLoginTvComplete(true)
        getConfig()?.client === 'starhub' && setIsSubmitting(false)
    }

    //forget password method will trigger after click on forget button
    const handleLoginTVForgetForm =  () =>{
        //enable forget password screen
        setForgotPasswordTV(true)

        getConfig().userAuthType === 'BOTH' && dispatch(cancelAuthenticationWithSecondaryDevice())

        //disable login qr and form screen
        setShowLoginTVForm(true)
    }

    //forget password page is closed after click on close button
    const handleForgotPasswordClose =  () =>{
        //disable forgot password screen
        setForgotPasswordTV(false)

        getConfig().userAuthType === 'BOTH' && secondaryAuthenticate(OAuthStatus()?.status)

        //enable login qr and form screen
        setShowLoginTVForm(false)
    }

    const handleUsernameClose =  () =>{
        //disable where is my usernammme screen
        setshowWhereIsMyUsername(false) 

        setShowNewLoginForm(true)
        setShowNewLoginOtp(false)
    }

    const handleResendOtp = () =>{
       //after trigger resend otp button from otp screen, it should set solo tab
       const soloPosition = getConfig()?.authenticationTypeTv?.indexOf('solo');
       setTab(soloPosition)
       setFocus('solotabbutton')
    }

    // used bellow method for QR authentication
    const secondaryAuthenticate = async (status: any) => {
        isInternetConnected(async () => {
            if (
                status !== props?.voltApi?.Models?.OAuthDeviceFlowStatus.OAUTH_STATUS.PENDING_LOGIN_SECONDARY_DEVICE &&
                status !== props?.voltApi?.Models?.OAuthDeviceFlowStatus.OAUTH_STATUS.STARTING
            ) {
                try {
                    const deviceData = await getDeviceData();
                    if (!deviceData) {
                        dispatch(
                            pushNotification({
                                message: {
                                    tag: getI18n()?.formatMessage({ id: 'INVALID_DEVICE_DATA' }),
                                    type: "information",
                                },
                            }),
                        )
                    } else {
                        let deviceId = deviceData?.deviceId || deviceData?.uniqueDeviceId ;
                        if (deviceId && deviceId === 'unknown') {
                            deviceId = deviceData.deviceId;
                            dispatch(
                                pushNotification({
                                    message: {
                                        tag: getI18n()?.formatMessage({ id: 'SERIAL_NUMBER_PERMISSION' }),
                                        type: "information",
                                    },
                                }),
                            )
                        }
                        dispatch(
                            await authenticateWithSecondaryDevice({
                                deviceId,
                                deviceData: {
                                    ...deviceData
                                },
                                oauthProvider: 'auth',
                            }),
                        );
                    }
                } catch (error) {
                    dispatch(
                        pushNotification({
                            message: {
                                tag: error,
                                type: "failure",
                            },
                        }),
                    )
                }
            }
        })
    };


    // Handle loading state based on OAuth status
    createEffect(() => {
        if (
            authenticationStatus() === props?.voltApi?.Constants.authenticationStatus.FAILED &&
            OAuthStatus()?.status === props?.voltApi?.Models?.OAuthDeviceFlowStatus?.OAUTH_STATUS.CANCELED_BY_USER &&
            authenticationStatusErrorCode() === 'NAV-212-NAG'
        ) {
            setLoginTvComplete(true)
        } else if (
            authenticationStatus() === props?.voltApi?.Constants.authenticationStatus.FAILED &&
            OAuthStatus()?.status ===
                props?.voltApi?.Models?.OAuthDeviceFlowStatus?.OAUTH_STATUS
                    .LOGIN_SECONDARY_DEVICE_REQUIRE_LOGIN_TV_SERVICE
        ) {
            setShowTvidSelection(false)
            setIsSubmitting(false)
            dispatch(cancelAuthenticationWithSecondaryDevice())
            secondaryAuthenticate(OAuthStatus()?.status)
            dispatch(clearTvids())
        } else if (
            (OAuthStatus()?.status ===
                props?.voltApi?.Models?.OAuthDeviceFlowStatus?.OAUTH_STATUS.PENDING_LOGIN_SECONDARY_DEVICE ||
                OAuthStatus()?.status === props?.voltApi?.Models?.OAuthDeviceFlowStatus?.OAUTH_STATUS.ERROR) &&
            OAuthStatus()?.verificationUri &&
            getConfig().userAuthType === 'BOTH'
        ) {
            setIsLoading(false)
            services() && dispatch(clearTvids())
        } else {
            getConfig().userAuthType === 'BOTH' && setIsLoading(true)

            // after login in starhub, if page refreshed then it should show loader, not want to display qr screen with login
            getConfig().userAuthType === 'BOTH' &&
                localStorage.getItem(getAuthKey()) !== null &&
                !isPlatform('laptop') &&
                getConfig()?.client === 'starhub' &&
                setIsSubmitting(true)

            //with the help of bellow code, after scanning qr code , it will show full loader and hide right side login form
            getConfig().userAuthType === 'BOTH' &&
                OAuthStatus()?.status ===
                    props?.voltApi?.Models?.OAuthDeviceFlowStatus?.OAUTH_STATUS
                        .LOGIN_SECONDARY_DEVICE_REQUIRE_LOGIN_TV_SERVICE &&
                setIsSubmitting(true)
        }
    });


    //  with bellow code it will trigger device/token call before login in every 3 second
    const handleSecondaryAuthenticate = async () =>{
        if(showLoginTVLang() && showLoginTVTab() && !showLoginTVForm() && getConfig().userAuthType === 'BOTH' && window.navigator.onLine && localStorage.getItem(getAuthKey()) === null && !isPlatform('laptop') && isLoginTvComplete() && window.navigator.onLine){
            if (
                OAuthStatus()?.status === props?.voltApi?.Models?.OAuthDeviceFlowStatus.OAUTH_STATUS.NOT_STARTED ||
                OAuthStatus()?.status === props?.voltApi?.Models?.OAuthDeviceFlowStatus?.OAUTH_STATUS.TIMEOUT_LOGIN_SECONDARY_DEVICE ||
                OAuthStatus()?.status === props?.voltApi?.Models?.OAuthDeviceFlowStatus?.OAUTH_STATUS.ERROR ||
                (
                    authenticationStatus() === props?.voltApi?.Constants.authenticationStatus.FAILED && 
                    (OAuthStatus()?.status === props?.voltApi?.Models?.OAuthDeviceFlowStatus.OAUTH_STATUS.CANCELED_BY_USER || OAuthStatus()?.status === props?.voltApi?.Models?.OAuthDeviceFlowStatus.OAUTH_STATUS.PENDING_LOGIN_SECONDARY_DEVICE || OAuthStatus()?.status === props?.voltApi?.Models?.OAuthDeviceFlowStatus?.OAUTH_STATUS.ERROR )
                )
            ) {
                await secondaryAuthenticate(OAuthStatus()?.status)
                !isPrevInternetStatus() && setPrevInternetStatus(true)
                !isPrevInternetStatus() && setCurrentInternetStatus(true)
            } 
        } 
    }
    createEffect(async () => {  
        await handleSecondaryAuthenticate()

        //use bellow to check online internet status
        const intervalId = setInterval(async () => {
            if(window.navigator.onLine === false){
                setPrevInternetStatus(false)
                setCurrentInternetStatus(false)
            }
            !isPrevInternetStatus() && window.navigator.onLine && setCurrentInternetStatus(true)
            isCurrentInternetStatus() && handleSecondaryAuthenticate()

          }, 3000);

        // Cleanup interval on component unmount
        onCleanup(() => clearInterval(intervalId));   
    });
    //qr code end

    const updateExitStatus = (flag: boolean, buttonName?: string) => {
        const lastFocusedElement = document.getElementById(showExitPopUp()?.lastFocused)
        if (lastFocusedElement && lastFocusedElement?.tagName === 'INPUT') lastFocusedElement?.focus?.()
        if (lastFocusedElement) setFocus(showExitPopUp()?.lastFocused)

        setShowExitPopUp({
            show: false,
            lastFocused: '',
            isInput: false
        })
    }

    return (
        <AuthorizationContext.Provider value={{ authorizationHandler: () => authorizationHandler() as any }}>
            <Show
                when={
                    (((authenticationStatus() === 'NOT_STARTED' || localStorage.getItem(LocalStorageKeys.OIDC_OAUTH_TOKEN) === null) && waitForProfile()) ||
                        authenticationStatus() === props?.voltApi?.Constants.authenticationStatus.FAILED ||
                        profileFailed()) &&
                    window.location.pathname !== '/settings' &&
                    (getConfig()?.authenticationType === 'oauth') &&
                    !isAuthPending()
                }
            >
                <Login
                    onLogin={() => authorizationHandler()?.signIn()}
                    onGuestLogin={guestLogin}
                    failed={authenticationStatus() === props?.voltApi?.Constants.authenticationStatus.FAILED}
                />
            </Show>

            <Show
                when={
                    ((localStorage.getItem(LocalStorageKeys.OIDC_OAUTH_TOKEN) === null && waitForProfile()) ||
                        authenticationStatus() === props?.voltApi?.Constants.authenticationStatus.FAILED ||
                       !profileFailed() && waitForProfile()) &&
                    window.location.pathname !== '/settings'
                }
            >
                {/* login button and laguage selection code start */}
                <Show when={!showLoginTVLang() && !showLoginTVTab() && !showLoginTVForm() && !isAuthPending() && isPlatform('laptop') &&
                    (getConfig()?.authenticationTypeTv?.includes('iptv') || getConfig()?.authenticationTypeQr === 'device')}>
                    <LoginLanguage onLanguageSelectionComplete={() => setShowLoginTVLang(true)} />
                </Show>
                <Show when={showLoginTVLang() && !showLoginTVTab() && !showLoginTVForm()  && !isAuthPending() && !isPlatform('laptop') && (getConfig()?.authenticationTypeTv?.includes('iptv') || getConfig()?.authenticationTypeQr === 'device')}>
                    <LoginTVTab
                        onLoginTVTab={handleLoginTVTab}
                        onGuestLogin={guestLogin}
                        onLoginSettingsTVTab={handleLoginSettingsTVTab}
                        failed={authenticationStatus() === props?.voltApi?.Constants.authenticationStatus.FAILED}

                    />
                </Show>
                 {/* login button and laguage selection code end */}

                {/* starhub QR with login part code start */}
                <Show when={showLoginTVLang() && showLoginTVTab() && !showLoginTVForm() && getConfig().userAuthType === 'BOTH'}>
                    <FocusGroupProvider id={`logintvform-screen`} focusKey={`logintvform-screen-qr`} onFocus={() => {}}>
                        <div
                            style={{
                                display: 'flex',
                                'justify-content': 'center',
                                'align-items': 'center',
                                height: '100vh',
                                'background-image': `url(${icons.get('LoginBackdrop')})`,
                                'background-size': 'cover',
                                direction: `${getConfig().rtlLanguages.includes(locale()) ? 'rtl' : 'ltr'}`
                            }}
                        >
                                <Show when={isSubmitting()}>
                                    <div class="login-content-tvform-qr-loader">
                                    <div class="client_logo_loading_logout_screen"></div>
                                    <div class="login-content-tvform-left-loader">
                                        <Spinner />
                                    </div>
                                    </div>
                                </Show>
                                <Show when={!isSubmitting()}>
                                    <div class="login-content-tvform-qr">
                                        <div class="client_logo_loading_logout_screen"></div>
                                        <div class="login-content-tvform-qr-inner">
                                            <div class='login-content-tvform-box login-content-tvform-left'>
                                                <Show when={authenticationStatus() === props?.voltApi?.Constants.authenticationStatus.FAILED || (isLoading() && isAuthPending())}>
                                                    <div class="login-content-tvform-left-loader">
                                                        <Spinner />
                                                    </div>
                                                </Show>
                                                <Show when={OAuthStatus()?.verificationUri && !isLoading() && isAuthPending() && OAuthStatus()?.status !== props?.voltApi?.Models?.OAuthDeviceFlowStatus.OAUTH_STATUS.CANCELED_BY_USER }>
                                                    <QrLogin 
                                                        verificationUri = {OAuthStatus()?.verificationUri}
                                                    />
                                                </Show>
                                            </div>
                                            <div class="login-content-tvform-box login-content-tvform-center">
                                                <div class="vertical-line-login" />
                                                <div class="or">{getI18n()?.formatMessage({ id: 'OR' })}</div>
                                                <div class="vertical-line-login" />
                                            </div>
                                            <div class='login-content-tvform-box login-content-tvform-right'>
                                                <LoginTVForm
                                                    onLoginTVForm={handleTvLogin}
                                                    username={username()}
                                                    password={password()}
                                                    statusCode={authenticationStatusErrorCode()}   
                                                    OAuthStatus={OAuthStatus()?.status}
                                                    failed={
                                                        authenticationStatus() ===
                                                            props?.voltApi?.Constants.authenticationStatus.FAILED &&
                                                        authenticationStatusErrorCode() !== 'NAV-212-NAG' &&
                                                        authenticationStatusErrorCode() !== 'NAV-212-HUA'
                                                    }                                                     
                                                    onLoginTVForgetForm={handleLoginTVForgetForm}
                                                    onLoginTVComplete={handleLoginTVComplete}
                                                    />
                                            </div>
                                        </div>
                                    </div>
                                </Show>
                        </div>
                    </FocusGroupProvider>
                </Show>
                {/* starhub QR with login part code end */}
            </Show>

            {/* starhub IPTV login part without QR start || ooredoo IPTV login for web || also shows forgot password in starhub */}
            <Show 
                when={
                    (getConfig()?.client === 'starhub') ||
                    (isPlatform('laptop') && getConfig()?.client === 'ooredoo' && getConfig().userAuthType === 'LOGIN')}>
                <Show
                    when={
                        ((localStorage.getItem(LocalStorageKeys.OIDC_OAUTH_TOKEN) === null && waitForProfile()) ||
                            authenticationStatus() === props?.voltApi?.Constants?.authenticationStatus.FAILED ||
                            profileFailed()) &&
                        window.location.pathname !== '/settings' &&
                        getConfig()?.authenticationTypeTv?.includes('iptv') &&
                        !isAuthPending()
                    }
                >
                    <Show when={showLoginTVLang() && showLoginTVTab() && !showLoginTVForm() && getConfig().userAuthType === 'LOGIN'}>
                    <FocusGroupProvider id={`logintvform-screen`} focusKey={`logintvform-screen-login-single`} onFocus={() => {}}>
                        <div
                            class = "logintvform-screen-login-single"
                            style={{
                                'background-image': `url(${icons.get('LoginBackdrop')})`,
                                direction: `${getConfig().rtlLanguages.includes(locale()) ? 'rtl' : 'ltr'}`
                            }}
                        >
                        <Show when={isSubmitting()}>
                            <div class="login-content-tvform-starhub-loader">
                                <div class="client_logo_loading_logout_screen"></div>
                                <div class="login-content-tvform-starhub-loader-spinner">
                                    <Spinner />
                                </div>
                            </div>
                        </Show>
                        <Show when={!isSubmitting()}>
                            <LoginTVForm
                                onLoginTVForm={handleTvLogin}
                                username={username()}
                                password={password()}
                                statusCode={authenticationStatusErrorCode()}   
                                OAuthStatus={OAuthStatus()?.status}
                                failed={
                                    authenticationStatus() ===
                                        props?.voltApi?.Constants.authenticationStatus.FAILED &&
                                    authenticationStatusErrorCode() !== 'NAV-212-NAG' &&
                                    authenticationStatusErrorCode() !== 'NAV-212-HUA'
                                }                                 
                                onLoginTVForgetForm={handleLoginTVForgetForm}
                                onLoginTVComplete={handleLoginTVComplete}
                            />
                        </Show>
                        </div>
                    </FocusGroupProvider>
                    </Show>
                    <Show when={(showForgotPasswordTV() && showLoginTVForm() && !isAuthPending() )}> 
                        <ForgotPassword
                            onLoginTVForgetClose={handleForgotPasswordClose}
                        />
                    </Show>
                </Show>
            </Show>
             {/* starhub IPTV login part without QR end || ooredoo IPTV login for web */}
            

            {/* Tab code for ooredoo start*/}
            <Show when={
                ((localStorage.getItem(LocalStorageKeys.OIDC_OAUTH_TOKEN) === null && waitForProfile()) ||
                    authenticationStatus() === props?.voltApi?.Constants?.authenticationStatus.FAILED) && !isAuthPending() &&
                window.location.pathname !== '/settings' && getConfig()?.authenticationTypeTv?.length > 0
            }
            >
                <Show when={!showWhereIsMyUsername() && !showForgotPasswordTV() && !isPlatform('laptop') && getConfig()?.client === 'ooredoo'}>
                    <FocusGroupProvider id={`logintv-tab-screen`} focusKey={`logintv-tab-screen`} onFocus={() => { }}>
                        <div
                            id={`${isPlatform('laptop') ? 'logintv-tab-screen' : ''}`}
                            class="logintv-tab-main"
                            style={{
                                display: "flex",
                                'justify-content': 'center',
                                'align-items': 'center',
                                height: '100vh',
                                'background-image': `url(${icons.get('LoginBackdrop')})`,
                                'background-size': 'cover',
                                direction: `${getConfig().rtlLanguages.includes(locale()) ? 'rtl' : 'ltr'}`
                            }}
                        >
                            {/* show loader after submit solo or login form in ooredoo start*/}
                            <Show when={isSubmittingOoredoo()}>
                                <div class="login-content-tvform-tab-loader">
                                    <div class="client_logo_loading_logout_screen"></div>
                                    <div class="login-content-tvform-tab-loader-spinner">
                                        <Spinner />
                                    </div>
                                </div>
                            </Show>
                            {/* show loader after submit solo or login form in ooredoo end*/}

                            {/* show login form and solo with tabs start*/}
                            <Show when={!isSubmittingOoredoo()}>
                                <div class="logintv-tab-main-inner">
                                <Show when={(getConfig()?.authenticationTypeTv?.length || 0) > 1}>
                                    {/* Tab Buttons */}
                                    <div id="tvtabbutton-inner" style={{ display: "flex", gap: "10px" }}>
                                        <For each={getConfig()?.authenticationTypeTv || []}>
                                            {(authType, index) => (
                                                <FocusableProvider
                                                    id={`${authType}tabbutton`}
                                                    focusKey={`${authType}tabbutton`}
                                                    onEnterPress={() => setTab(index())}
                                                    onFocus={() => {
                                                        document.getElementById(`${authType}tabbutton`)?.focus();
                                                    }}
                                                >
                                                    {(focused: any) => (
                                                        <button
                                                            id={`${authType}tabbuttonid`}
                                                            class={`auth-common-tab-class ${focused?.() || tab() === index() ? 'authtabactiveclass-focus' : 'tabnonactiveclass'
                                                                }`}
                                                            tabIndex={focused?.() ? 0 : -1}
                                                            type="submit"
                                                            onClick={() => setTab(index())}
                                                        >
                                                            {getI18n()?.formatMessage({ id: authType.toUpperCase() })}
                                                        </button>
                                                    )}
                                                </FocusableProvider>
                                            )}
                                        </For>
                                    </div>
                                    </Show>

                                    {/* Tab Content */}
                                    <Switch>
                                        <For each={getConfig()?.authenticationTypeTv || []}>
                                            {(authType, index) => (
                                                <Match when={(getConfig()?.authenticationTypeTv?.length || 0) === 1 || tab() === index()}>
                                                    {authType === 'iptv' && (
                                                        <Show
                                                            when={
                                                                ((localStorage.getItem(LocalStorageKeys.OIDC_OAUTH_TOKEN) === null && waitForProfile()) ||
                                                                    authenticationStatus() === props?.voltApi?.Constants?.authenticationStatus.FAILED ||
                                                                    !profileFailed() && waitForProfile()) &&
                                                                window.location.pathname !== '/settings'
                                                            }
                                                        >
                                                            {/* IPTV Content */}
                                                            <Show when={showLoginTVLang() && showLoginTVTab() && !showLoginTVForm() && getConfig().userAuthType !== 'BOTH' && !isAuthPending()}>
                                                                <LoginTVForm
                                                                    onLoginTVForm={handleTvLogin}
                                                                    username={username()}
                                                                    password={password()}
                                                                    statusCode={authenticationStatusErrorCode()}   
                                                                    OAuthStatus={OAuthStatus()?.status}
                                                                    failed={
                                                                        authenticationStatus() ===
                                                                            props?.voltApi?.Constants.authenticationStatus.FAILED &&
                                                                        authenticationStatusErrorCode() !== 'NAV-212-NAG' &&
                                                                        authenticationStatusErrorCode() !== 'NAV-212-HUA'
                                                                    }
                                                                    onLoginTVForgetForm={handleLoginTVForgetForm}
                                                                    onLoginTVComplete={handleLoginTVComplete}
                                                                />
                                                            </Show>
                                                            <Show when={(showForgotPasswordTV() && showLoginTVForm() && !isAuthPending() && (OAuthStatus()?.status === props?.voltApi?.Models?.OAuthDeviceFlowStatus.OAUTH_STATUS.CANCELED_BY_USER || getConfig().userAuthType !== 'BOTH'))}>
                                                                <ForgotPassword
                                                                    onLoginTVForgetClose={handleForgotPasswordClose}
                                                                />
                                                            </Show>
                                                        </Show>
                                                    )}
                                                    {authType === 'solo' && (
                                                        <Show
                                                            when={
                                                                ((localStorage.getItem(LocalStorageKeys.OIDC_OAUTH_TOKEN) === null && waitForProfile()) ||
                                                                    authenticationStatus() === props?.voltApi?.Constants.authenticationStatus.FAILED ||
                                                                    profileFailed()) &&
                                                                window.location.pathname !== '/settings' &&
                                                                !isAuthPending()
                                                            }
                                                        >
                                                            {/* Solo Content */}
                                                            <Show when={showNewLoginForm() && !showNewLoginOtp()}>
                                                                <Show when={eDSConnectivity() === "CONNECTED"}>
                                                                    <NewLogin
                                                                        onClickLoginButton={onClickLoginButtonHandler}
                                                                        setUsernameOrEmail={setUsernameOrEmail}
                                                                        usernameOrEmail={usernameOrEmail()}
                                                                        onClickUsernameButton={onClickUsernameButton}
                                                                    />
                                                                </Show>
                                                                <Show when={eDSConnectivity() === "DISCONNECTED" || eDSConnectivity() === 'PENDING'}>
                                                                    <SoloNoInternetScreen checkEDSConnectivity={onCheckEDSConnectivity} eDSConnectivity={eDSConnectivity()} />
                                                                </Show>
                                                            </Show>
                                                            <Show when={!showNewLoginForm() && showNewLoginOtp()}>
                                                                <LoginOtp
                                                                    pinSize={6}
                                                                    username={usernameOrEmail()}
                                                                    onCompleteOtp={onCompleteOtp}
                                                                    voltApi={props?.voltApi}
                                                                    resetStates={resetStates}
                                                                    otpText={otpText()}
                                                                    authenticationStatus={authenticationStatus()}
                                                                    resentOtp={handleResendOtp}
                                                                    setIsSubmittingOoredoo={setIsSubmittingOoredoo}
                                                                    setShowNewLoginForm={setShowNewLoginForm}
                                                                    setShowNewLoginOtp={setShowNewLoginOtp}
                                                                />
                                                            </Show>
                                                        </Show>
                                                        // solo end
                                                    )}
                                                    {/* Add other authentication type content here if needed */}
                                                </Match>
                                            )}
                                        </For>
                                    </Switch>
                                </div>

                            </Show>
                            {/* show login form and solo with tabs end*/}
                        </div>
                    </FocusGroupProvider>
                </Show>
            </Show>
            {/* Tab code ooredoo end*/}

            {/* where is my username ooredoo code start */}
            <Show
                when={
                    ((localStorage.getItem(LocalStorageKeys.OIDC_OAUTH_TOKEN) === null && waitForProfile()) ||
                        authenticationStatus() === props?.voltApi?.Constants?.authenticationStatus.FAILED ||
                        profileFailed()) &&
                    window.location.pathname !== '/settings' &&
                    getConfig()?.authenticationTypeTv?.includes('solo') &&
                    !isAuthPending()
                }
            >
                <Show when={showWhereIsMyUsername() && !showNewLoginForm() && !showNewLoginOtp()}>
                    <WhereIsMyUsername 
                    onLoginTVUsernameClose={handleUsernameClose}
                    /> 
                </Show>
            </Show>
            {/* where is my username ooredoo code end */}

            <Show
                when={
                    (!isAuthPending() &&
                        !waitForProfile() &&
                        !profileFailed() &&
                        authenticationStatus() !== props?.voltApi?.Constants?.authenticationStatus.FAILED) ||
                    window.location.pathname === '/settings'
                }
                fallback={<LoadingScreen />}
            >
                {props.children}
            </Show>

            <Show when={showTvidSelection()}>
                <SubscriptionSelector services={services()} onClose={() => setShowTvidSelection(false)}/>
            </Show>

             <Show when={showExitPopUp().show}>
                <QuitPopUp updateLogoutStatus={updateExitStatus} />
            </Show>
        </AuthorizationContext.Provider>
    )
}

export interface AuthorizationProviderBehavior {
    authorizationHandler?: () => AuthorizationHandler
}
